export default {
  qrcode: 'qrcode',
};
